import React from "react";
import ExamAnswerSheetModalState, { ExamAnswerSheetModalProps } from "./ExamAnswerSheetModal.models";
import './ExamAnswerSheetModal.scss';
import { Modal } from "react-bootstrap";
import { ExamQuestionsView } from "../../../models/dtos/exams/questions/ExamQuestionsView";

export default class ExamAnswerSheetModal extends React.PureComponent<ExamAnswerSheetModalProps, ExamAnswerSheetModalState>{

    constructor(props: any) {
        super(props);
        this.state = { showModal: false };
    }

    openModal = (question?: ExamQuestionsView) => {
        this.setState({ showModal: true, question: question })
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    render(): React.ReactNode {
        let { showModal, question } = this.state;
        let content;
        if (question !== null && question !== undefined) {
            content = (<>
                <div className="col-12">
                    <label className="f-s-14 display-blok">پاسخ تشریحی : </label>
                    <label className="f-s-14">
                        <span dangerouslySetInnerHTML={{ __html: question.answerSheet ?? "" }}></span>
                    </label>
                </div>

                {question.answerSheetAttachmentId !== null && question.answerSheetAttachmentId !== undefined && question.answerSheetAttachmentId !== '' ? (<div className="col-12">
                    <label className="f-s-14 display-blok">تصویر پاسخنامه :</label>
                    <div className="answer-sheet-image-area">
                        <img src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${question.answerSheetAttachmentId}`} className="thumb" />
                    </div>
                </div>) : (<></>)}

                {question.fullAttachment !== null && question.fullAttachment !== undefined && question.fullAttachment !== '' ? (<div className="col-12">
                    <label className="f-s-14 display-blok">تصویر سوال همراه با پاسخ :</label>
                    <div className="answer-sheet-image-area">
                        <img src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${question.fullAttachment}`} className="thumb" />
                    </div>
                </div>) : (<></>)}
            </>);
        }
        else content = (<></>);
        return (<>
            <Modal show={showModal} onHide={this.closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label> مشاهده پاسخ کامل </label>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    {content}
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-outline-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal>
        </>);
    }
}